
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-matching",
      function () {
        return require("private-next-pages/job-matching.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-matching"])
      });
    }
  